<template>
    <div v-if="isFeatureEnabled" class="canvas-toolbar-top">
        <div class="toolbar-container d-flex justify-content-center align-items-center">
            <canvas-toolbar-top-preview-buttons />
            <div>
                <c-button
                    v-tippy
                    content="Add preview"
                    size="icon"
                    :icon="['far', 'plus']"
                    class="add-button"
                    variant="secondary"
                    @click="onAddPreview"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import store from '@/store';
import { Roles } from '@/typings/user';
import StoreType from '@/typings/storeType';

import CButton from '@/components/shared/CButton';
import CanvasToolbarTopPreviewButtons from './previews/CanvasToolbarTopPreviewButtons.vue';

const canvas = computed(() => {
    return store.state.storeLayers?.canvas;
});

const flags = computed(() => {
    return store.state.storeLayers?.flags;
});

const isFeatureEnabled = computed(() => {
    if (flags.value?.isMyProductBases || flags.value?.isProductTemplate) {
        return false;
    }

    const user = store.state.user;
    if (!user) return false;

    const roles = user.AccessRoles?.Serialized.split(',');

    const isAdmin = roles?.includes(Roles.ADMIN);
    const impersonatedFromAdminUser = user.ImpersonatedFromAdminUser;
    const impersonatedFromChildUser = user.ImpersonatedFromChildUser;
    const isMultiPreview = roles?.includes(Roles.MULTI_PREVIEW);
    const stores = store.state.user?.Stores || [];
    const allStoresAreShopify = stores.length > 0 && stores.every((store) => store.Type === StoreType.Shopify);

    return Boolean(
        (isAdmin || impersonatedFromAdminUser || isMultiPreview || allStoresAreShopify) && !impersonatedFromChildUser
    );
});

const onAddPreview = () => {
    if (!canvas.value) return;
    canvas.value.addPreview();
};
</script>

<style scoped lang="scss">
@import 'styles/utilities/functions';

.canvas-toolbar-top {
    position: absolute;
    top: 10px;
    width: 100%;
    z-index: 1;
}

.toolbar-container {
    margin: 0 20px;
}

.toolbar-container .add-button {
    color: get-color('gray-600');
    height: 40px;
    width: 40px;
    border-radius: 4px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.25) !important;
    margin: 0.2rem;
    background-color: #f2f2f2;

    &:hover {
        border-color: get-color('purple');
        background-color: #f2f2f2;
        color: get-color('gray-600');
    }
}
</style>
